import { ResponsiveSwarmPlot } from '@nivo/swarmplot'

import { VoiceAgentAnalysisResultName } from 'src/graphql/types/voiceAgentResult'
import { formatSnakeValue } from 'src/lib/formatters'

const VoiceAgentSwarmPlot = ({ voiceAgentAnalysisResults }) => {
  const scatterPlotData = voiceAgentAnalysisResults.map((result) => ({
    group: result.name,
    duration: result.activityLog.callDuration,
  }))

  return (
    <div className="flex h-[250px] flex-row items-center justify-between">
      <ResponsiveSwarmPlot
        data={scatterPlotData}
        groups={Object.values(VoiceAgentAnalysisResultName)}
        identity="group"
        value="duration"
        valueFormat={(value) => `${(value / 60).toFixed(1)}m`}
        size={16}
        layout="horizontal"
        forceStrength={4}
        simulationIterations={100}
        borderColor={{
          from: 'color',
          modifiers: [
            ['darker', 0.6],
            ['opacity', 0.5],
          ],
        }}
        margin={{ bottom: 60, left: 120, right: 30 }}
        axisTop={null}
        enableGridX={false}
        axisRight={null}
        axisBottom={{
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Call Length (Seconds)',
          legendPosition: 'middle',
          legendOffset: 46,
          truncateTickAt: 0,
        }}
        axisLeft={{
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: 'middle',
          legendOffset: -76,
          truncateTickAt: 0,
          format: (value) => formatSnakeValue(value),
        }}
      />
    </div>
  )
}

export default VoiceAgentSwarmPlot
